import {
    PartialUpdateTarget,
    UserGroupView,
    UserOverview,
} from "api/generated/model";

export type UserOrUserGroupOverview = UserOverview | UserGroupView;

function toUserOverview(user: UserOverview): UserOverview {
    return {
        id: user.id,
        firstname: user.firstname,
        lastname: user.lastname,
        email: user.email,
    };
}

function mapUserOrUserGroupOverview<T>(
    userOrUserGroup: UserOrUserGroupOverview,
    mapUser: (user: UserOverview) => T,
    mapUserGroup: (userGroup: UserGroupView) => T
): T {
    if ((userOrUserGroup as UserOverview).firstname) {
        return mapUser(userOrUserGroup as UserOverview);
    } else {
        return mapUserGroup(userOrUserGroup as UserGroupView);
    }
}

function userOrUserGroupToPartialUpdateTarget(
    userOrUserGroup: UserOrUserGroupOverview
): PartialUpdateTarget {
    let kind: "User" | "UserPool";
    let id: number;
    if ((userOrUserGroup as UserOverview).firstname) {
        kind = "User";
        id = (userOrUserGroup as UserOverview).id;
    } else {
        kind = "UserPool";
        id = (userOrUserGroup as UserGroupView).id;
    }

    return { kind, data: id };
}

export {
    toUserOverview,
    mapUserOrUserGroupOverview,
    userOrUserGroupToPartialUpdateTarget,
};
